/**
 * Contractor Mappers
 *
 * Functions to map API responses to UI props
 */

import type { ContractorCard } from '@hummii/shared-types';
import type { ContractorCardProps } from '../ui/ContractorCard';

/**
 * API response type matches ContractorCard from shared-types
 */
export type ContractorApiResponse = ContractorCard;

/**
 * Map API contractor (from shared-types) to ContractorCardProps
 */
export function mapContractorToCardProps(
  contractor: ContractorApiResponse,
): ContractorCardProps {
  return {
    id: contractor.id,
    userId: contractor.userId, // User ID for profile navigation
    name: contractor.name,
    avatarUrl: contractor.avatarUrl,
    rating: contractor.rating, // From UserRatingStats via API
    hourlyRate: contractor.hourlyRate,
    city: contractor.city,
    province: contractor.province,
    latitude: contractor.latitude,
    longitude: contractor.longitude,
    completedOrders: contractor.completedOrders,
    isVerified: contractor.isVerified,
    categories: contractor.categories,
  };
}

/**
 * Map array of contractors
 */
export function mapContractorsToCardProps(
  contractors: ContractorApiResponse[],
): ContractorCardProps[] {
  return contractors.map(mapContractorToCardProps);
}
